/* @fe-toolkit/utility: derive chunk publicPath from the executing script URL */
(function () {
	if (typeof document === "undefined") return;
	var __ggAnchors = ["static/js/","static/"];
	var __ggDirOf = function (src) {
		var url = String(src || "").replace(/[?#].*$/, "");
		if (!/^https?:\/\//.test(url)) return "";
		return url.replace(/\/[^/]*$/, "/");
	};
	var __ggStrip = function (dir, anchor) {
		if (!dir || dir.slice(-anchor.length) !== anchor) return "";
		return dir.slice(0, dir.length - anchor.length);
	};
	var __ggCurrent = document.currentScript;
	if (__ggCurrent && __ggCurrent.src) {
		var __ggDir = __ggDirOf(__ggCurrent.src);
		for (var __ggA = 0; __ggA < __ggAnchors.length; __ggA++) {
			var __ggBase = __ggStrip(__ggDir, __ggAnchors[__ggA]);
			if (__ggBase) { __webpack_require__.p = __ggBase; return; }
		}
		return;
	}
	var __ggEntry = __ggAnchors[0];
	var __ggTags = document.getElementsByTagName("script");
	for (var __ggI = __ggTags.length - 1; __ggI >= 0; __ggI--) {
		var __ggFound = __ggStrip(__ggDirOf(__ggTags[__ggI].src), __ggEntry);
		if (__ggFound) { __webpack_require__.p = __ggFound; return; }
	}
})();